require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-gdpr-and-data-protection.json") })
        }
      }, "path---blog-gdpr-and-data-protection");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-gdpr-and-data-protection!./.cache/json/blog-gdpr-and-data-protection.json
// module id = 823
// module chunks = 231608221292675